import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
} from '@mui/material'
import { COLORS } from '~theme/colors'
import { spacing } from '~theme/global'

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    primary: true
    secondary: true

    //default mui variants
    outlined: true
    elevation: false
  }
}
export interface MuiAccordionData {
  defaultProps?: ComponentsProps['MuiAccordion']
  styleOverrides?: ComponentsOverrides['MuiAccordion']
  variants?: ComponentsVariants['MuiAccordion']
}

export const MuiAccordion: MuiAccordionData = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      '&::before': {
        display: 'none',
      },
      '& .MuiAccordionSummary-root': {
        paddingTop: spacing(3),
        paddingBottom: spacing(3),
        paddingLeft: spacing(4),
        paddingRight: spacing(4),
        borderRadius: '4px',
        '&:hover': {
          background: `${COLORS.secondary.blueTint}`,
        },
        '&.Mui-expanded': {
          minHeight: 'auto',
          '& .Mui-expanded': {
            margin: 0,
          },
        },
      },
      '& .MuiAccordionSummary-content': {
        margin: 0,
      },
      '& .MuiAccordionDetails-root': {
        paddingTop: spacing(2),
        paddingBottom: spacing(2),
        paddingLeft: spacing(4),
        paddingRight: spacing(4),
      },
    },
  },
  variants: [
    {
      props: {
        variant: 'primary',
      },
      style: {
        '& .MuiAccordionSummary-root': {
          background: COLORS.greys.ultraLight,

          '&.Mui-expanded': {
            backgroundColor: COLORS.primary.white,
            border: `solid 1px ${COLORS.primary.maerskBlue}`,
          },
        },
      },
    },
    {
      props: {
        variant: 'secondary',
      },
      style: {
        '& .MuiAccordionDetails-root': {
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        },
        '& .MuiAccordionSummary-root': {
          background: COLORS.greys.ultraLight,
          paddingLeft: spacing(3),

          '&.Mui-expanded': {
            backgroundColor: COLORS.greys.ultraLight,
            border: 'none',
          },
        },
        '& .MuiCollapse-root': { background: COLORS.greys.ultraLight },
      },
    },
  ],
}
